import React, { useEffect, useState } from 'react';
import Frame from "../assets/images/icons/Frame.svg";
import Vector1 from "../assets/images/icons/Vector (1).svg";
import Vector3 from "../assets/images/icons/Vector (3).svg";
  import { v4 as uuid } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { addBooking } from '../redux/booking/actionCreators';
import { Tooltip } from 'react-tooltip'

const AddBooking = () => {
  const dispatch = useDispatch();
  const {totalBookings} = useSelector((state) => state)

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [date, setDate] = useState("");
  const [guest, setGuest] = useState("");
  const [seatClass, setSeatClass] = useState("");


  const handleSubmit = (e) => {
    e.preventDefault();

    if(totalBookings >= 3){
      return;
    }
    const data = {
      id: uuid(), 
      from,
      to,
      date,
      guest,
      seatClass
    }

    dispatch(addBooking(data))
  }
    return (
        <div>
               <div className="mt-[160px] mx-4 md:mt-[160px] relative">
      <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
        <form className="first-hero lws-inputform" onSubmit={handleSubmit}>
  {/*         <!-- From --> */}
          <div className="des-from">
            <p>Destination From</p>
            <div className="flex flex-row">
              <img src={Frame} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="from" id="lws-from" onChange={(e)=> setFrom(e.target.value)} required>
                <option value="" hidden>Please Select</option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>

      {/*     <!-- To --> */}
          <div className="des-from">
            <p>Destination To</p>
            <div className="flex flex-row">
              <img src={Frame} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="to" id="lws-to" onChange={(e)=> setTo(e.target.value)} required>
                <option value="" hidden>Please Select</option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>
{/* 
          <!-- Date --> */}
          <div className="des-from">
            <p>Journey Date</p>
            <input type="date" className="outline-none px-2 py-2 w-full date" name="date" id="lws-date" onChange={(e)=> setDate(e.target.value)} required />
          </div>

       {/*    <!-- Guests --> */}
          <div className="des-from">
            <p>Guests</p>
            <div className="flex flex-row">
              <img src={Vector1} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="guests" id="lws-guests" onChange={(e)=> setGuest(e.target.value)} required>
                <option value="" hidden>Please Select</option>
                <option value="1">1 Person</option>
                <option value="2">2 Persons</option>
                <option value="3">3 Persons</option>
                <option value="4">4 Persons</option>
              </select>
            </div>
          </div>

       {/*    <!-- Class --> */}
          <div className="des-from !border-r-0">
            <p>Class</p>
            <div className="flex flex-row">
            <img src={Vector3} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="ticketClass" id="lws-ticketClass" onChange={(e)=> setSeatClass(e.target.value)} required>
                <option value="" hidden>Please Select</option>
                <option>Business</option>
                <option>Economy</option>
              </select>
            </div>
          </div>

          <button style={totalBookings >= 3 ? {backgroundColor:"gray", color:"#000", cursor:"not-allowed", boxShadow:'none'} : {}} className="addCity" type="submit" id="lws-addCity" data-tooltip-id="alert-tooltip">
            <svg width="15px" height="15px" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            <span className="text-sm">Book</span>
          </button>
           {totalBookings >= 3 &&  <Tooltip id="alert-tooltip" variant="error" content="Sorry, You can have only 3 bookings at a time"/>}
        </form>
        
      </div>
    </div>
        </div>
    );
};

export default AddBooking;